import React from 'react'; // Removed useState, useEffect, useRef
import { Link } from 'react-router-dom';

// --- LOCAL IMAGE IMPORTS (FIXED) ---
import InteriorImage1 from '../../../assets/Images/Interior16.jpg'; // Residential 1 (No change)
import InteriorImage2 from '../../../assets/Images/Interior37.jpg'; // Residential 2 (No change)
// FIXED: Interior48.jpg (broken) -> Interior47.jpg
import InteriorImage3 from '../../../assets/Images/Interior47.jpg'; // Commercial 1
import InteriorImage4 from '../../../assets/Images/Interior54.jpg'; // Commercial 2 (No change)
import InteriorImage5 from '../../../assets/Images/Interior75.jpg'; // Furnishings 1 (No change)
// FIXED: Interior69.jpg (broken) -> Interior71.jpg
import InteriorImage6 from '../../../assets/Images/Interior71.jpg'; // Furnishings 2
// FIXED: Interior51.jpg (broken) -> Interior52.jpg
import InteriorImage7 from '../../../assets/Images/Interior52.jpg'; // Planning 1
import InteriorImage8 from '../../../assets/Images/Interior49.jpg'; // Planning 2 (No change)
// FIXED: Interior32.jpg (broken) -> Interior34.jpg
import InteriorImage9 from '../../../assets/Images/Interior34.jpg'; // Materials 1
// FIXED: Interior22.jpg (broken) -> Interior21.jpg
import InteriorImage10 from '../../../assets/Images/Interior21.jpg'; // Materials 2
// FIXED: Interior36.jpg (broken) -> Interior35.jpg
import InteriorImage11 from '../../../assets/Images/Interior35.jpg'; // Lighting 1
import InteriorImage12 from '../../../assets/Images/Interior117.jpg'; // Lighting 2 (No change)


// --- REMOVED AnimateOnScroll Component ---


const Services = () => {
    return (
        <section id="services-full" className="py-24 overflow-hidden bg-white text-gray-800">
            <style>{`
                /* Custom styles for Red/Black/White theme */
                .text-gradient-red-black {
                    background-image: linear-gradient(to right, #DC2626, #1F2937); /* Red and Dark Gray/Black */
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .bg-brand-red { background-color: #DC2626; }
                .bg-brand-dark { background-color: #1F2937; }
                .btn-red { 
                    border: 2px solid #DC2626; 
                    color: #DC2626;
                    padding: 0.75rem 2rem;
                    text-transform: uppercase;
                    font-weight: 600;
                    transition: all 0.3s;
                }
                .btn-red:hover { 
                    background-color: #DC2626; 
                    color: white; 
                }
                .btn-dark {
                    border: 2px solid #1F2937; 
                    color: #1F2937;
                    padding: 0.75rem 2rem;
                    text-transform: uppercase;
                    font-weight: 600;
                    transition: all 0.3s;
                }
                .btn-dark:hover { 
                    background-color: #1F2937; 
                    color: white; 
                }
                
                /* Base styles for uniform image - applies to desktop first, then overridden by mobile */
                .uniform-image {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    aspect-ratio: 3/2; /* --- NEW: Default (Desktop) is wider --- */
                    transform: scale(1.1);
                    transition: transform 0.3s ease-out;
                }
                .image-container {
                    overflow: hidden;
                    border-radius: 0.5rem;
                    position: relative;
                    box-shadow: 0 15px 30px rgba(0,0,0,0.3);
                    transition: transform 0.3s ease-out, box-shadow 0.3s ease-out;
                }
                .image-container:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 20px 40px rgba(0,0,0,0.4);
                }
                .image-container:hover .uniform-image {
                    transform: scale(1.15);
                }

                .large-image-block {
                    height: 100%;
                    min-height: 450px; /* --- NEW: Adjusted min-height for desktop to be slightly taller than previous wide, but not as much as mobile --- */
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 1.5rem;
                    position: relative;
                    overflow: visible; 
                }

                /* --- DESKTOP Overlapping effect --- */
                .large-image-block .image-container:nth-child(1) {
                    z-index: 1; 
                }
                .large-image-block .image-container:nth-child(2) {
                    position: relative;
                    z-index: 2; 
                    transform: translateX(-25%) translateY(30px); /* --- NEW: Adjusted for wider desktop look --- */
                    margin-top: 0; 
                }

                /* Mobile-specific styles (max-width: 768px) - Overrides desktop for smaller screens */
                @media (max-width: 768px) {
                    .large-image-block {
                        min-height: auto; /* Reset min-height for mobile */
                        gap: 1rem;
                        grid-template-columns: repeat(2, 1fr); 
                    }
                    .large-image-block .uniform-image {
                        aspect-ratio: 3/4; /* --- MOBILE: Taller aspect ratio for mobile --- */
                        transform: scale(1.05); /* Slightly reduce initial scale on mobile to prevent too much cropping */
                    }
                    .large-image-block .image-container:nth-child(2) {
                        transform: translateX(-20%) translateY(30px); /* --- MOBILE: Overlap for mobile (taller, overlapping) --- */
                        margin-top: 0 !important; 
                    }
                }
            `}</style>
            <div className="container mx-auto px-6">
                {/* Replaced AnimateOnScroll with a simple div */}
                <div>
                    <div className="text-center mb-16">
                        <h2 className="text-4xl md:text-5xl headline-font text-gradient-red-black">Design & Execution Mastery</h2>
                        <p className="text-xl mt-4 max-w-2xl mx-auto">We transform concepts into cohesive, high impact spaces. Our services cover every phase of design, detailed planning, and flawless execution.</p>
                    </div>
                </div>

                {/* --- 1. Residential Interior Design --- */}
                <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                    {/* Replaced AnimateOnScroll with a simple div */}
                    <div>
                        <div>
                            <h3 className="text-4xl headline-font text-gradient-red-black">Residential Design</h3>
                            <div className="w-20 h-1 bg-brand-red my-6"></div>
                            <p className="text-lg mb-6">Creating bespoke homes that perfectly balance sophisticated aesthetics with practical, everyday luxury. Services include full home and room by room design.</p>
                            <Link to="contact" className="btn btn-red">Start My Home Project</Link>
                        </div>
                    </div>
                    {/* Replaced AnimateOnScroll with a simple div */}
                    <div>
                        <div className="large-image-block">
                            <div className="image-container"><img src={InteriorImage1} alt="Luxury living room design" className="uniform-image" /></div>
                            <div className="image-container"><img src={InteriorImage2} alt="Modern kitchen interior" className="uniform-image" /></div>
                        </div>
                    </div>
                </div>
                
                {/* --- 2. Commercial & Office Spaces --- */}
                <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                    {/* Replaced AnimateOnScroll with a div and applied layout classes */}
                    <div className="order-last md:order-first">
                        <div className="large-image-block">
                            <div className="image-container"><img src={InteriorImage3} alt="Modern office meeting room" className="uniform-image" /></div>
                            <div className="image-container"><img src={InteriorImage4} alt="Sleek retail store interior" className="uniform-image" /></div>
                        </div>
                    </div>
                    {/* Replaced AnimateOnScroll with a simple div */}
                    <div>
                        <div className="text-left md:text-right">
                            <h3 className="text-4xl headline-font text-gradient-red-black">Commercial & Retail</h3>
                            <div className="w-20 h-1 bg-brand-dark my-6 md:ml-auto"></div>
                            <p className="text-lg mb-6">Designing functional, impressive spaces that boost productivity and enhance brand identity, from corporate offices to engaging retail environments.</p>
                            <Link to="services" className="btn btn-dark">View Our Services</Link>
                        </div>
                    </div>
                </div>

                {/* --- 3. Custom Furniture & Millwork --- */}
                <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                    {/* Replaced AnimateOnScroll with a simple div */}
                    <div>
                        <div>
                            <h3 className="text-4xl headline-font text-gradient-red-black">Custom Furnishings</h3>
                            <div className="w-20 h-1 bg-brand-red my-6"></div>
                            <p className="text-lg mb-6">Crafting unique, built in furniture, cabinetry, and custom millwork designs that perfectly utilize your space and fit your aesthetic needs.</p>
                            <Link to="services" className="btn btn-red">Explore Custom Work</Link>
                        </div>
                    </div>
                    {/* Replaced AnimateOnScroll with a simple div */}
                    <div>
                        <div className="large-image-block">
                            <div className="image-container"><img src={InteriorImage5} alt="Custom built-in shelving unit" className="uniform-image" /></div>
                            <div className="image-container"><img src={InteriorImage6} alt="Bespoke wooden kitchen island" className="uniform-image" /></div>
                        </div>
                    </div>
                </div>
                
                {/* --- 4. Space Planning & 3D Visualization --- */}
                <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                    {/* Replaced AnimateOnScroll with a div and applied layout classes */}
                    <div className="order-last md:order-first">
                        <div className="large-image-block">
                            <div className="image-container"><img src={InteriorImage7} alt="Architectural floor plan" className="uniform-image" /></div>
                            <div className="image-container"><img src={InteriorImage8} alt="3D rendering of a dining area" className="uniform-image" /></div>
                        </div>
                    </div>
                    {/* Replaced AnimateOnScroll with a simple div */}
                    <div>
                        <div className="text-left md:text-right">
                            <h3 className="text-4xl headline-font text-gradient-red-black">Space Planning & 3D</h3>
                            <div className="w-20 h-1 bg-brand-dark my-6 md:ml-auto"></div>
                            <p className="text-lg mb-6">Meticulous spatial planning to maximize efficiency and flow. See your project come to life before construction begins with photorealistic 3D renders.</p>
                            <Link to="contact" className="btn btn-dark">Get a Layout Consultation</Link>
                        </div>
                    </div>
                </div>

                {/* --- 5. Materials & Finishes Consultation --- */}
                <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                    {/* Replaced AnimateOnScroll with a simple div */}
                    <div>
                        <div>
                            <h3 className="text-4xl headline-font text-gradient-red-black">Materials Consultation</h3>
                            <div className="w-20 h-1 bg-brand-red my-6"></div>
                            <p className="text-lg mb-6">Guidance on selecting premium flooring, wall treatments, countertops, and fixtures that align with your budget and design goals.</p>
                            <Link to="contact" className="btn btn-red">Request Samples</Link>
                        </div>
                    </div>
                    {/* Replaced AnimateOnScroll with a simple div */}
                    <div>
                        <div className="large-image-block">
                            <div className="image-container"><img src={InteriorImage9} alt="Selection of marble and wood materials" className="uniform-image" /></div>
                            <div className="image-container"><img src={InteriorImage10} alt="Texture board with fabrics and paint swatches" className="uniform-image" /></div>
                        </div>
                    </div>
                </div>

                {/* --- 6. Lighting Design & Home Automation --- */}
                <div className="grid md:grid-cols-2 gap-12 items-center">
                    {/* Replaced AnimateOnScroll with a div and applied layout classes */}
                    <div className="order-last md:order-first">
                        <div className="large-image-block">
                            <div className="image-container"><img src={InteriorImage11} alt="Modern layered lighting concept" className="uniform-image" /></div>
                            <div className="image-container"><img src={InteriorImage12} alt="Home automation tablet control" className="uniform-image" /></div>
                        </div>
                    </div>
                    {/* Replaced AnimateOnScroll with a simple div */}
                    <div>
                        <div className="text-left md:text-right">
                            <h3 className="text-4xl headline-font text-gradient-red-black">Smart Lighting & Tech</h3>
                            <div className="w-20 h-1 bg-brand-dark my-6 md:ml-auto"></div>
                            <p className="text-lg mb-6">Expert lighting plans to create ambiance and highlight features, seamlessly integrated with smart home technology for ultimate convenience.</p>
                            <Link to="contact" className="btn btn-dark">Schedule Tech</Link>
                        </div>
                    </div>
                </div>
                
            </div>
        </section>
    );
};

export default Services;